<script>
    import { routeNames } from '@app/router/constants';
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters('data/games', [
                'virtualGames',
                'virtualNumber',
                'virtualSport',
            ]),
            items() {
                return [
                    ...this.virtualNumber,
                    ...this.virtualSport
                ].map((game) => ({
                    id: game.redirectUrl,
                    name: game.name,
                }));
            },
            gameSlug() {
                return this.$route.params.virtualNameSlug;
            },
            activeItem() {
                const game = this.items.find((item) => item.id === this.gameSlug);
                if (!game) {
                    return null;
                }
                return game.id;
            },
        },
        methods: {
            openGame({ id: redirectUrl }) {
                this.$router.push({
                    name: routeNames.virtualGame,
                    params: {
                        virtualNameSlug: redirectUrl,
                    }
                });
            }
        },
        render() {
            return this.$scopedSlots.default({
                items: this.items,
                activeItem: {
                    name: this.activeItem,
                },
                onItemClick: (item) => {
                    this.openGame(item);
                }
            });
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/shared/components/VirtualGames/VirtualGamesSidebarContainer.vue